import React from 'react';

import ResourceApp from './resourceApp';
import LandingTemplate from '../../bizLanding/landingTemplate';
import { PATHS } from 'AppConstants';

const ResourcePage = (props) => {
	const { isMobile } = props;
	const loggedInHandler = () => {
		window.location = PATHS.MMT_BIZ_PROFILE_URL;
	};
	return (
		<LandingTemplate
			showChatBot
			headerLinks={[]}
			loggedInHandler={loggedInHandler}
			headerActions={{ showDemo: true, showSignup: true }}
			{...props}>
			<ResourceApp isMobile={isMobile} />
		</LandingTemplate>
	);
};

export default ResourcePage;
